import {
  Icon3DLine,
  IconBinocularsGray,
  IconBuildings,
  IconCctvLine,
  IconChainLink,
  IconClockGray,
  IconCloud,
  IconGlobal,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconShare,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';

import image1 from '@src/assets/images/digitaltwin/image/image1.avif';
import image2 from '@src/assets/images/digitaltwin/image/image2.avif';

import gis from '@src/assets/images/digitaltwin/video/gis.mp4';
import weather from '@src/assets/images/digitaltwin/video/weather.mp4';
import buildings from '@src/assets/images/digitaltwin/video/buildings.mp4';
import tracking from '@src/assets/images/digitaltwin/video/tracking.mp4';
import traffic from '@src/assets/images/digitaltwin/video/traffic.mp4';
import airplane from '@src/assets/images/digitaltwin/video/airplane.mp4';
import cctv from '@src/assets/images/digitaltwin/video/cctv.mp4';

export default {
  type: '도시 솔루션',

  banner: {
    title: '도시 인프라를 디지털 트윈으로 효율적으로 관리하세요.',
    desc: '도시의 인프라 상태와 운영 현황을 디지털 트윈 기술로 실시간 모니터링하고 효율적으로 관리하여 운영의 안정성과 효율성을 높입니다.',
  },

  video: {
    title: '디지털 트윈 기술로 도시의 모든 인프라 상태를 한눈에 파악하세요.',
    desc: '디지털 트윈 기술을 활용하여 도시 내 주요 인프라 시설의 상태와 운영 데이터를 실시간으로 통합하고, 시각화하여 체계적이고 효율적인 관리를 가능하게 합니다.',
    // play: mainVideo,
    image: image1,
  },

  func: [
    {
      theme: '디지털 트윈으로 도시 인프라 현황을 실시간으로 확인하고 관리하세요.',
      title: '실시간 3D 시각 데이터 제공',
      desc: '도시 내 건물과 내부 시설을 정확한 3D 모델로 구현하여 실시간 정보를 직관적으로 확인할 수 있으며, 시설 운영 현황과 상태를 신속하게 파악하여 효율적인 운영이 가능합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: gis,
    },
    {
      title: '대기 및 기상 정보 실시간 연동',
      desc: '현실 세계의 날씨 데이터를 시스템에 실시간으로 연동하여 비, 눈 등의 기상 상태를 실제와 동일하게 구현함으로써 보다 몰입감 있고 정확한 운영 대응이 가능합니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      video: weather,
    },
    {
      title: '건물 정보 실시간 구현',
      desc: '시설물 상태와 유지보수 일정을 실시간으로 모니터링하고, 센서 데이터를 통해 장비 고장과 에너지 소비를 예측하여 효율적인 운영과 친환경 관리를 지원합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      video: buildings,
    },
    {
      title: '실내 건물 실시간 맵 구현',
      desc: '실내에 있는 물건과 이동 중인 사람의 정보를 실시간으로 반영하여 유동인구 흐름과 보안 상황을 정확히 파악하고, 신속한 운영 관리 및 보안 대응을 지원합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      video: tracking,
    },
    {
      theme: '도시 전반의 이동 및 안전 정보를 통합하여 효율적인 운영을 지원합니다.',
      title: '실시간 사람 및 차량 이동 정보 관리',
      desc: '도시 내 차량과 사람의 이동 정보를 실시간으로 분석하여 교통 혼잡을 예방하고, 안전사고 발생 시 즉각 대응하여 신속하고 정확한 도시 운영을 지원합니다.',
      sub1: '자유로운 범위 설정',
      icon2: IconZoneGray,
      sub2: '여러 구역 설정',
      icon1: IconTagGray,
      image: image2,
    },
    {
      title: '대중교통 실시간 정보 연계',
      desc: '버스, 지하철 등 대중교통의 실시간 운행 정보를 제공해 최적의 경로를 안내하고 교통 혼잡을 최소화하여 도시의 교통 효율성을 크게 향상시킵니다.',
      sub1: '높은 정확도 제공',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      video: traffic,
    },
    {
      title: '항공기 운항 정보 실시간 연결',
      desc: '항공편의 실시간 운항 정보를 시스템과 연동하여 항공편의 지연이나 변경 사항을 즉각적으로 알림으로 제공하고, 이동 과정의 원활성을 높이며 운영 효율성을 개선합니다.',
      sub1: '빠른 설치 완료',
      icon1: IconTagGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      video: airplane,
    },
    {
      title: 'CCTV 영상 실시간 모니터링 및 관리',
      desc: '도시 내 CCTV 영상을 실시간으로 연결하여 이상 징후를 즉시 감지하고 범죄 예방과 교통 상황 관리에 신속히 대응하여 도시의 안전을 효과적으로 관리합니다.',
      sub1: '실시간 시각화',
      icon1: IconShareGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      video: cctv,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '',

    data: [
      {
        icon: Icon3DLine, // 실시간 3D 시각화
        title: '실시간 3D 시각화',
        desc: '도시 시설의 실시간 3D 구현 및 모니터링 지원',
      },
      {
        icon: IconCloud, // 실시간 기상정보 연동
        title: '실시간 기상정보 연동',
        desc: '현실 날씨 데이터를 실시간으로 시스템과 연계',
      },
      {
        icon: IconBuildings, // 건물 정보 확인
        title: '건물 정보 확인',
        desc: '건물 시설의 상태와 에너지 소비 실시간 모니터링',
      },
      {
        icon: IconRoom, // 실내 실시간 맵 구현
        title: '실내 실시간 맵 구현',
        desc: '실내 물건 및 사람의 위치 실시간 지도화 제공',
      },
      {
        icon: IconRoute, // 사람·차량 이동 분석
        title: '사람·차량 이동 분석',
        desc: '차량과 사람의 실시간 이동 데이터 분석 및 대응',
      },
      {
        icon: IconChainLink, // 대중교통 정보 연계 (없으면 ChainLink)
        title: '대중교통 정보 연계',
        desc: '버스, 지하철 등 실시간 위치 정보 제공',
      },
      {
        icon: IconShare, // 항공기 정보 실시간 연결 (없으면 ChainLink)
        title: '항공기 정보 실시간 연결',
        desc: '항공기 운항 정보를 실시간으로 시스템에 연동',
      },
      {
        icon: IconCctvLine, // CCTV 실시간 모니터링
        title: 'CCTV 실시간 모니터링',
        desc: 'CCTV 영상을 실시간 분석하여 도시 안전 관리',
      },
      {
        icon: IconGlobal, // 지리정보 플랫폼 연계 → Global: GIS 상징
        title: '지리정보 플랫폼 연계',
        desc: 'GIS 데이터와 연계하여 공간정보 효율적 관리',
      },
      {
        icon: IconChainLink, // 외부 시스템 API 연동 → ChainLink: 연동 상징
        title: '외부 시스템 API 연동',
        desc: '다양한 시스템의 데이터를 유연하게 통합 지원',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
